import { Center, Loader as MantineLoader } from "@mantine/core";

export default function Loader({ height }) {
  return (
    <Center style={{ height }}>
      <MantineLoader size="md" />
    </Center>
  );
}
